<!-- components/TechStackCard.vue -->
<template>
  <div class="tech-stack-card">
    <div class="thumbnail">
      <img :src="require(`@/assets/tech/${logo}`)" :alt="altText" @error="onImageError" />
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'TechStackCard',
  props: {
    logo: String,
    altText: String
  },
  methods: {
    onImageError(event) {
      console.error('Image failed to load:', event.target.src);
      event.target.src = '@/assets/placeholder.png'; // Fallback image if available
    }
  }
}
</script>

<style scoped>
.tech-stack-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 110px;
  margin-bottom: 40px;
  border-radius: 8px;
  border: 2px solid transparent;
  transition: border-color 0.3s ease;
}

.thumbnail {
  height: auto;
}

img{
  width: 50px;
}
.thumbnail img {
  width: 100%;
  display: block;
}

.tech-stack-card:hover .tech-stack-card {
  border-color: #9d6cf0;
}

.arrow img {
  width: 12px;
  height: 12px;
  filter: invert(66%) sepia(58%) saturate(674%) hue-rotate(325deg) brightness(96%) contrast(91%);
}
</style>